// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1AkJF","title":"AfterFrontImage_title__3LS4e"};